module.exports = "https://cdn.dove.it/_next/static/public/assets/features/feature_1.0bb01bc136b788a791f7e4b644789580.png";